export default "__VITE_ASSET__D938l1Gf__"